import React from 'react';
import { Calculator, Megaphone } from '@phosphor-icons/react';
import { colors } from '../../style/theme';
import { staticImageUrl } from '../../util/images';
import { BusinessProduct } from '../../types';

export const businessProducts: BusinessProduct[] = [
  {
    name: 'Corporate Giving',
    pageAnchorTag: 'corporate-giving',
    summary:
      'Make a 100% tax-deductible donation to our novel 501(c)(3) climate portfolio.',
    description:
      'Highlight your company’s climate giving while also progressing toward 1% For The Planet® certification.',
    colors: {
      primary: colors.wrenGreen,
      secondary: colors.wrenGreenLowOpacity,
    },
    icon: (
      <svg
        width="60%"
        height="60%"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.866 0C7.5661 0 0 7.5661 0 16.866C0 25.7005 6.83182 32.9529 15.4858 33.6596C15.6359 32.8247 15.8322 32.0331 16.0919 31.2944C15.8726 30.7918 15.7065 30.2691 15.5648 29.7395C14.4449 28.7613 13.2859 26.6433 12.5573 23.6124H15.6703C16.0396 22.3829 16.603 21.2478 17.3536 20.2392H11.9874C11.8744 19.1784 11.8062 18.0585 11.8062 16.866C11.8062 15.6736 11.8744 14.5537 11.9874 13.4928H21.7447C21.8492 14.4677 21.9058 15.4982 21.916 16.5827C22.9347 16.1054 24.0525 15.7499 25.2365 15.5121C25.2112 14.8341 25.2016 14.1422 25.1409 13.4928H29.9141C30.0642 14.0696 30.1742 14.663 30.2501 15.2651C31.5573 15.3848 32.728 15.6182 33.6826 15.8712C33.1649 7.03508 25.8303 0 16.866 0ZM16.866 3.37321C18.2878 3.37321 20.1527 5.87106 21.1748 10.1196H12.5573C13.5794 5.87106 15.4442 3.37321 16.866 3.37321ZM10.8608 4.79957C10.1069 6.29896 9.50514 8.09738 9.08855 10.1196H5.19816C6.52383 7.83933 8.49281 5.98357 10.8608 4.79957ZM22.8713 4.79957C25.2376 5.98357 27.2082 7.83933 28.5339 10.1196H24.6468C24.2302 8.09738 23.6252 6.29896 22.8713 4.79957ZM3.81792 13.4928H8.59113C8.48994 14.5773 8.43301 15.704 8.43301 16.866C8.43301 18.0281 8.48994 19.1547 8.59113 20.2392H3.81792C3.53794 19.1581 3.37321 18.0332 3.37321 16.866C3.37321 15.6989 3.53794 14.5739 3.81792 13.4928ZM5.19816 23.6124H9.08526C9.50185 25.6347 10.1069 27.4331 10.8608 28.9325C8.4945 27.7485 6.52383 25.8927 5.19816 23.6124Z"
          fill="#00836C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.5535 18.5527C26.174 18.5527 23.7759 19.1667 21.8565 20.5391C19.9371 21.9115 18.5525 24.1733 18.5525 26.9265C18.5525 28.262 18.912 29.7564 19.8339 31.0672C18.5721 33.2754 18.5525 35.7706 18.5525 37.1054H21.9257C21.9257 36.084 22.0767 34.4674 22.5681 33.215C23.3767 33.5378 24.2912 33.7322 25.2989 33.7322C27.1626 33.7322 28.7228 33.1598 29.8053 32.1806C30.8878 31.2014 31.4606 29.9751 31.9267 28.8008C32.0903 28.3889 32.2428 27.9802 32.3929 27.5777C33.0988 25.6861 33.7531 23.9329 35.2571 22.6276L37.2501 20.8982L34.842 19.8144C34.842 19.8144 32.0725 18.5527 28.5535 18.5527ZM30.7337 22.2824C30.9031 22.3417 31.0815 22.4041 31.2912 22.4661C30.1208 24.2961 29.3465 26.1642 28.7942 27.5556C28.3951 28.5611 27.9946 29.2713 27.5424 29.6803C27.0903 30.0893 26.5548 30.3589 25.2991 30.3589C23.837 30.3589 23.1685 29.9005 22.6737 29.2751C22.1788 28.6497 21.9259 27.7193 21.9259 26.9264C21.9259 25.2219 22.6218 24.1399 23.8201 23.2831C25.0184 22.4262 26.7775 21.9259 28.5537 21.9259C29.715 21.9259 30.1759 22.0872 30.7337 22.2824Z"
          fill="#00836C"
        />
      </svg>
    ),
    perks: [
      '1% For The Planet® partner',
      '100% tax-deductible',
      'Donations support carbon removal and ecosystem restoration',
    ],
    screenshot: {
      imageUrl: staticImageUrl('browser-corporate-giving.png'),
      title: 'An innovative approach to corporate giving',
      description:
        'Easily make donations to our curated portfolio of non-profit solutions to support carbon removal, ecosystem restoration, and more.',
    },
    features: [
      {
        title:
          'Become a Community Matching Partner to maximize your brand’s exposure',
        description:
          'Simply check a box, and your donation will be used to publicly match contributions from Wren’s consumer subscribers who offset their emissions monthly.',
        icon: (
          <svg
            width="32"
            height="24"
            viewBox="0 0 32 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.3333 6.66667H18.6667V10.6667H14.6667V13.3333H18.6667V17.3333H21.3333V13.3333H25.3333V10.6667H21.3333V6.66667ZM2.66667 12C2.66667 8.28 4.85333 5.06667 8.01333 3.57333V0.693333C3.36 2.34667 0 6.78667 0 12C0 17.2133 3.36 21.6533 8.01333 23.3067V20.4267C4.85333 18.9333 2.66667 15.72 2.66667 12ZM20 0C13.3867 0 8 5.38667 8 12C8 18.6133 13.3867 24 20 24C26.6133 24 32 18.6133 32 12C32 5.38667 26.6133 0 20 0ZM20 21.3333C14.8533 21.3333 10.6667 17.1467 10.6667 12C10.6667 6.85333 14.8533 2.66667 20 2.66667C25.1467 2.66667 29.3333 6.85333 29.3333 12C29.3333 17.1467 25.1467 21.3333 20 21.3333Z"
              fill="#00836C"
            />
          </svg>
        ),
      },
      {
        title:
          'Progress toward your company’s 1% For The Planet® certification',
        description:
          'Wren is a 1% For The Planet® partner, and donations can count toward your company’s certification.',
        icon: (
          <svg
            width="21"
            height="28"
            viewBox="0 0 21 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.86554 0.00200552C7.56087 0.0133711 7.2503 0.0729039 6.94701 0.183693C5.73382 0.624264 4.97887 1.7457 5.02668 3.03769C5.03184 3.17594 4.96369 3.26113 4.90555 3.31023C4.84741 3.35932 4.74966 3.40931 4.61788 3.38088C3.35689 3.10698 2.11716 3.65747 1.47116 4.77634C0.82387 5.89521 0.967605 7.23945 1.83453 8.19811C1.93143 8.30535 1.92814 8.42506 1.91781 8.48578C1.9036 8.56072 1.86262 8.66091 1.74117 8.72551C0.599043 9.33016 0.00482481 10.5441 0.229632 11.8167C0.45444 13.0893 1.42727 14.0269 2.70764 14.2039C2.84201 14.222 2.91747 14.3033 2.95494 14.3679C2.99241 14.4325 3.02428 14.5378 2.9726 14.6657C2.57528 15.6442 2.73055 16.6955 3.3385 17.502L0 23.258H4.52199V23.2605L6.44737 27.4822L10.5 20.727L14.5526 27.4822L16.478 23.258H21L17.6817 17.5373C18.3114 16.7267 18.4742 15.6599 18.0703 14.6657C18.0199 14.5391 18.0543 14.4338 18.0905 14.3679C18.128 14.3033 18.2034 14.222 18.3378 14.2039C19.6181 14.0269 20.591 13.0893 20.8158 11.8167C21.0406 10.5441 20.4464 9.33016 19.3043 8.72551C19.1828 8.66091 19.1418 8.56072 19.1276 8.48578C19.1173 8.42506 19.114 8.30535 19.2109 8.19811C20.0778 7.23945 20.2216 5.8965 19.5743 4.77634C18.9283 3.65618 17.6885 3.10827 16.4275 3.38088C16.2932 3.40931 16.198 3.35932 16.1399 3.31023C16.0817 3.26113 16.0136 3.17465 16.0187 3.03769C16.0665 1.74699 15.3116 0.625556 14.0984 0.183693C12.8826 -0.25817 11.5861 0.114349 10.7902 1.13503C10.6209 1.35079 10.4245 1.35208 10.2552 1.13503C9.65736 0.369518 8.77954 -0.0320911 7.86554 0.00200552ZM8.03965 2.59609C8.10393 2.61402 8.16274 2.6545 8.21377 2.71974C9.32618 4.15386 11.7116 4.15257 12.8266 2.71974C12.9274 2.59054 13.059 2.55316 13.2102 2.60871C13.3639 2.66427 13.4399 2.77649 13.4348 2.93928C13.4012 3.84626 13.7805 4.70209 14.4769 5.28607C15.172 5.87005 16.0774 6.09553 16.9676 5.90431C17.1316 5.86943 17.2508 5.92498 17.3335 6.06581C17.4161 6.20793 17.4004 6.34307 17.2906 6.46451C16.6807 7.13894 16.4213 8.03708 16.5789 8.93243C16.7379 9.82649 17.2882 10.5854 18.0905 11.0092C18.2365 11.0854 18.2955 11.206 18.2671 11.3675C18.2387 11.529 18.141 11.6206 17.9795 11.6426C17.0789 11.7679 16.3019 12.2916 15.8472 13.0784C15.3937 13.864 15.3307 14.7974 15.673 15.6372C15.7351 15.7884 15.7025 15.9199 15.5771 16.0258C15.4505 16.1305 15.3141 16.1401 15.1784 16.0536C14.4071 15.5704 13.4774 15.4697 12.6247 15.781C11.772 16.0924 11.121 16.7651 10.8407 17.6307C10.7425 17.9434 10.298 17.9434 10.1972 17.6307C9.91812 16.7664 9.26836 16.0936 8.41565 15.7835C8.08748 15.6634 7.75105 15.6044 7.41384 15.6044C6.87379 15.6044 6.33733 15.7563 5.86446 16.0561C5.72492 16.1439 5.59366 16.1343 5.46575 16.0283C5.34172 15.9224 5.30662 15.7921 5.36734 15.6422C5.70972 14.8011 5.64671 13.8653 5.19322 13.0784C4.73973 12.2903 3.96144 11.7704 3.06092 11.6451C2.89942 11.6232 2.80291 11.529 2.77577 11.3675C2.74735 11.2073 2.80519 11.0867 2.94989 11.0092C3.75222 10.5854 4.30251 9.82902 4.46143 8.93495C4.61905 8.0396 4.36217 7.14017 3.75234 6.46704C3.64252 6.3443 3.62805 6.21046 3.70944 6.06834C3.79084 5.92751 3.90744 5.87066 4.07282 5.90684C4.963 6.10064 5.86835 5.87387 6.56345 5.2886C7.26112 4.7059 7.63922 3.85008 7.60562 2.9418C7.60046 2.77772 7.67646 2.66556 7.83021 2.60871C7.90579 2.58158 7.97538 2.57817 8.03965 2.59609ZM7.40123 18.1884C7.45177 18.1864 7.49691 18.1982 7.53244 18.2111C7.6035 18.2369 7.69802 18.2951 7.73937 18.4256C7.8595 18.7981 8.04796 19.1244 8.2819 19.4072L6.7199 22.0089C6.26317 21.2148 5.45153 20.674 4.52199 20.674H4.48666L5.63482 18.6905C6.18274 18.6985 6.73633 18.5562 7.2372 18.2414C7.29534 18.2052 7.35068 18.1903 7.40123 18.1884ZM13.6417 18.1884C13.6922 18.1903 13.7513 18.2039 13.8107 18.2414C14.296 18.5463 14.8299 18.6897 15.3627 18.6905L16.5133 20.674H16.478C15.5495 20.674 14.737 21.2132 14.2801 22.0089L12.7358 19.435C12.9817 19.1461 13.1803 18.8106 13.3061 18.4256C13.3487 18.2951 13.4419 18.2369 13.513 18.2111C13.5472 18.1982 13.5911 18.1864 13.6417 18.1884Z"
              fill="#00836C"
            />
          </svg>
        ),
      },
      {
        title: 'Support carbon removal, ecosystem restoration, and more',
        description:
          'Wren has pioneered the first non-profit climate portfolio that funds carbon removal, ecosystem restoration, climate policy, and more.',
        icon: (
          <svg
            width="29"
            height="20"
            viewBox="0 0 29 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.5 0C11.0055 0 7.9781 2.0477 6.46647 5.04395C2.8306 5.44895 0 8.6325 0 12.5C0 16.6425 3.24558 20 7.25 20H22.9583C26.2945 20 29 17.2013 29 13.75C29 10.45 26.5211 7.7752 23.3879 7.54395C22.565 3.2427 18.8995 0 14.5 0ZM9.50854 7.49268C10.5078 7.49268 11.3103 7.7668 11.9181 8.31055C12.5247 8.8543 12.8697 9.60408 12.9518 10.5591H10.9718C10.9573 10.0403 10.8322 9.66717 10.5942 9.44092C10.3573 9.21467 9.9943 9.10156 9.50854 9.10156C9.01434 9.10156 8.65252 9.29279 8.42293 9.67529C8.19335 10.0578 8.07272 10.6688 8.06185 11.5063V12.1094C8.06064 13.0181 8.16877 13.6652 8.38989 14.0552C8.61102 14.4452 8.99087 14.6411 9.52979 14.6411C9.98654 14.6411 10.336 14.5303 10.5776 14.3091C10.8181 14.0866 10.9455 13.7333 10.96 13.2495H12.9329C12.9064 13.842 12.7531 14.3656 12.4704 14.8193C12.1876 15.2731 11.792 15.6253 11.2809 15.874C10.771 16.124 10.1859 16.25 9.52979 16.25C8.44833 16.25 7.59617 15.885 6.97388 15.1562C6.35159 14.4263 6.04167 13.3979 6.04167 12.0679V11.6455C6.04167 10.8118 6.18257 10.0806 6.46411 9.45557C6.74444 8.83057 7.14912 8.34662 7.67717 8.00537C8.204 7.66412 8.81496 7.49268 9.50854 7.49268ZM17.2424 7.5C17.9396 7.5 18.5618 7.6702 19.1091 8.0127C19.6553 8.35645 20.079 8.84379 20.3835 9.47754C20.6868 10.1113 20.8401 10.839 20.8438 11.6577V12.0508C20.8438 12.8808 20.695 13.6166 20.3977 14.2554C20.0992 14.8954 19.6766 15.3874 19.128 15.7324C18.5806 16.0787 17.955 16.25 17.2542 16.25C16.5521 16.25 15.9299 16.0833 15.3874 15.7495C14.8448 15.4158 14.4221 14.9388 14.12 14.3188C13.8155 13.6988 13.6542 12.9888 13.641 12.1851V11.7041C13.641 10.8704 13.7886 10.1358 14.0846 9.49707C14.3807 8.85957 14.8057 8.36627 15.3567 8.02002C15.9089 7.67252 16.5367 7.5 17.2424 7.5ZM17.2424 9.10645C16.2467 9.10645 15.7226 9.87834 15.6659 11.4233L15.6611 12.0508C15.6611 12.8845 15.7941 13.5259 16.0623 13.9746C16.3306 14.4234 16.7261 14.6484 17.2542 14.6484C17.7544 14.6484 18.141 14.4281 18.4129 13.9868C18.6836 13.5468 18.8223 12.9112 18.8259 12.085V11.6943C18.8259 10.8481 18.6907 10.2044 18.4176 9.76562C18.1421 9.32687 17.7499 9.10645 17.2424 9.10645ZM23.3926 11.25H23.3949H23.3973C23.9942 11.2504 24.4558 11.3857 24.7779 11.6553C25.1005 11.9253 25.2641 12.3136 25.2641 12.8198C25.2641 13.1323 25.1795 13.418 25.0139 13.6768C24.8484 13.9368 24.4844 14.2866 23.9189 14.7266L23.6168 15H25.375V16.25H21.75V15.3271L23.3761 13.7476C23.5694 13.5651 23.9543 13.2151 23.9543 12.8589C23.9543 12.5439 23.7874 12.3486 23.4563 12.3486C23.3016 12.3486 23.1823 12.4092 23.0929 12.5342C23.0034 12.6604 22.9583 12.812 22.9583 12.9907H21.75C21.75 12.4995 21.9045 12.0879 22.2102 11.7529C22.5149 11.4203 22.9079 11.2524 23.3926 11.25Z"
              fill="#00836C"
            />
          </svg>
        ),
      },
    ],
  },
  {
    name: 'Climate-positive Workforce',
    pageAnchorTag: 'climate-positive-workforce',
    summary: 'Remove workforce carbon emissions as an employee benefit.',
    description:
      'Accurately offset employee emissions and share your team’s climate-positive impact.',
    colors: {
      primary: colors.projectPolicy,
      secondary: colors.projectPolicyLowOpacity,
    },
    icon: (
      <svg
        width="60%"
        height="60%"
        viewBox="0 0 39 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.80469 0C4.45734 0 1.73437 2.72297 1.73437 6.07031C1.73437 8.17215 2.80992 10.0277 4.43756 11.1176C1.86765 12.2177 0 14.5159 0 17.3438H3.46875C3.46875 15.5633 5.25547 13.875 7.80469 13.875C10.3539 13.875 12.1406 15.5633 12.1406 17.3438H15.6094C15.6094 14.5159 13.7417 12.2177 11.1718 11.1176C12.7995 10.0277 13.875 8.17215 13.875 6.07031C13.875 2.72297 11.152 0 7.80469 0ZM7.80469 3.46875C9.23901 3.46875 10.4062 4.63598 10.4062 6.07031C10.4062 7.50464 9.23901 8.67188 7.80469 8.67188C6.37036 8.67188 5.20312 7.50464 5.20312 6.07031C5.20312 4.63598 6.37036 3.46875 7.80469 3.46875ZM30.3516 17.3438C27.0042 17.3438 24.2812 20.0667 24.2812 23.4141C24.2812 25.5159 25.3568 27.3714 26.9844 28.4614C24.4145 29.5615 22.5469 31.8597 22.5469 34.6875H26.0156C26.0156 32.9071 27.8023 31.2188 30.3516 31.2188C32.9008 31.2188 34.6875 32.9071 34.6875 34.6875H38.1562C38.1562 31.8597 36.2886 29.5615 33.7187 28.4614C35.3463 27.3714 36.4219 25.5159 36.4219 23.4141C36.4219 20.0667 33.6989 17.3438 30.3516 17.3438ZM30.3516 20.8125C31.7859 20.8125 32.9531 21.9797 32.9531 23.4141C32.9531 24.8484 31.7859 26.0156 30.3516 26.0156C28.9172 26.0156 27.75 24.8484 27.75 23.4141C27.75 21.9797 28.9172 20.8125 30.3516 20.8125Z"
          fill="#5B27F0"
        />
        <path
          d="M19.0782 3.46875V0C27.1932 0 34.0341 5.59403 35.9105 13.1535L32.5433 13.9902C31.0446 7.95212 25.6013 3.46875 19.0782 3.46875Z"
          fill="#5B27F0"
        />
        <path
          d="M2.53052 22.5469L5.83667 21.5069C7.60484 27.1303 12.8503 31.2188 19.0782 31.2188V34.6875C11.3305 34.6875 4.74447 29.588 2.53052 22.5469Z"
          fill="#5B27F0"
        />
      </svg>
    ),
    perks: [
      'Flexible budget caps',
      'Support local climate projects',
      'Verified offsets and removals',
    ],
    screenshot: {
      imageUrl: staticImageUrl('browser-climate-positive-workforce2.png'),
      title: 'Detailed workforce carbon calculator',
      description:
        'Interested employees can use Wren’s detailed carbon calculator to learn about their footprint and offset it.',
    },
    features: [
      {
        title: 'Comprehensive calculator',
        description:
          'Backed by proprietary research from UC Berkeley and World Bank, Wren’s calculator is comprehensive and intuitive to use.',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="24"
            viewBox="0 0 18 24"
            fill="none"
          >
            <path
              d="M2.25 0.970703C1.00688 0.970703 0 1.961 0 3.18365V20.8872C0 22.1099 1.00688 23.1002 2.25 23.1002H15.75C16.9931 23.1002 18 22.1099 18 20.8872V3.18365C18 1.961 16.9931 0.970703 15.75 0.970703H2.25ZM2.25 3.18365H15.75V5.3966H2.25V3.18365ZM2.25 7.60955H15.75V20.8872H2.25V7.60955ZM4.5 9.8225V12.0354H6.75V9.8225H4.5ZM7.875 9.8225V12.0354H10.125V9.8225H7.875ZM11.25 9.8225V12.0354H13.5V9.8225H11.25ZM4.5 13.1419V15.3549H6.75V13.1419H4.5ZM7.875 13.1419V15.3549H10.125V13.1419H7.875ZM11.25 13.1419V15.3549H13.5V13.1419H11.25ZM4.5 16.4613V18.6743H6.75V16.4613H4.5ZM7.875 16.4613V18.6743H13.5V16.4613H7.875Z"
              fill="#5B27F0"
            />
          </svg>
        ),
      },
      {
        title: 'Shareable impact profile',
        description:
          'Employees can share their impact profile with friends and family to inspire others to take action.',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="24"
            viewBox="0 0 23 24"
            fill="none"
          >
            <path
              d="M11.5 0.937988C5.14855 0.937988 0 6.00176 0 12.2486C0 18.4955 5.14855 23.5592 11.5 23.5592C17.8514 23.5592 23 18.4955 23 12.2486C23 6.00176 17.8514 0.937988 11.5 0.937988ZM11.5 3.20011C16.5807 3.20011 20.7 7.25158 20.7 12.2486C20.7 14.0553 20.1542 15.7335 19.2266 17.1462L18.3416 16.4724C16.5568 15.1185 13.2675 14.5107 11.5 14.5107C9.73245 14.5107 6.44205 15.1185 4.6584 16.4724L3.77344 17.1484C2.84515 15.7354 2.3 14.0559 2.3 12.2486C2.3 7.25158 6.4193 3.20011 11.5 3.20011ZM11.5 5.17947C9.4392 5.17947 7.7625 6.82856 7.7625 8.85543C7.7625 10.8823 9.4392 12.5314 11.5 12.5314C13.5608 12.5314 15.2375 10.8823 15.2375 8.85543C15.2375 6.82856 13.5608 5.17947 11.5 5.17947ZM11.5 7.4416C12.2923 7.4416 12.9375 8.07613 12.9375 8.85543C12.9375 9.63473 12.2923 10.2693 11.5 10.2693C10.7077 10.2693 10.0625 9.63473 10.0625 8.85543C10.0625 8.07613 10.7077 7.4416 11.5 7.4416ZM11.5 16.7729C15.0658 16.7729 16.9833 18.0945 17.8812 18.7566C16.2265 20.3265 13.9804 21.2971 11.5 21.2971C9.01962 21.2971 6.77352 20.3265 5.11885 18.7566C6.01669 18.0945 7.93418 16.7729 11.5 16.7729ZM18.2989 18.3281C18.1728 18.4644 18.0469 18.6016 17.9126 18.7301C18.0465 18.6024 18.1717 18.4638 18.2989 18.3281Z"
              fill="#5B27F0"
            />
          </svg>
        ),
      },
      {
        title: 'Custom impact portfolios',
        description:
          'Work with Wren to plan a custom portfolio of climate solutions to fit your businesses budget and brand.',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <path
              d="M12 0.987305C5.3868 0.987305 0 6.2854 0 12.7897C0 19.294 5.3868 24.5921 12 24.5921C18.6132 24.5921 24 19.294 24 12.7897C24 6.2854 18.6132 0.987305 12 0.987305ZM10.8 3.42846V11.6095H2.48203C3.02177 7.32982 6.4487 3.95932 10.8 3.42846ZM13.2 3.42846C17.9451 4.00736 21.6 7.96175 21.6 12.7897C21.6 14.9763 20.8449 16.9804 19.5844 18.5779L13.2 12.301V3.42846ZM2.48203 13.9699H11.5031L17.8852 20.2492C16.2609 21.489 14.2232 22.2316 12 22.2316C7.09122 22.2316 3.07062 18.6369 2.48203 13.9699Z"
              fill="#5B27F0"
            />
          </svg>
        ),
      },
    ],
  },
  {
    name: 'One-off Purchases',
    pageAnchorTag: 'one-off-purchases',
    summary: 'Confidently purchase verified carbon removal or offsets.',
    description:
      'Purchase from a Wren-managed climate portfolio, create your own, or select a single project.',
    colors: {
      primary: colors.wrenOrange,
      secondary: colors.wrenOrangeLowOpacity,
    },
    icon: (
      <svg
        width="60%"
        height="60%"
        viewBox="0 0 40 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.73989 0L3.60281 0.0281195L3.62039 3.62742L7.34622 3.60984L8.84359 7.20211H11.2197V7.20562H34.7276L29.7294 16.2039H16.7452V16.2004H14.5624L11.3743 21.2865C10.6545 22.4382 10.6173 23.8931 11.2759 25.0791C11.9346 26.2651 13.1844 27.0018 14.5413 27.0018H35.9895V23.4025H14.5413L14.4253 23.1916L16.5448 19.8032H29.7294C31.0377 19.8032 32.2417 19.0918 32.8752 17.9508L39.3603 6.27768C39.6716 5.71979 39.6631 5.04278 39.3392 4.49209C39.0153 3.9432 38.4227 3.60633 37.7856 3.60633H11.2443L9.73989 0ZM0 10.8014V14.4007H11.4446L11.5185 14.2917L13.7118 10.8014H0ZM0 18V21.5993H6.91037L9.19508 18H0ZM14.3937 28.8014C13.4391 28.8014 12.5236 29.1806 11.8486 29.8556C11.1736 30.5306 10.7944 31.4461 10.7944 32.4007C10.7944 33.3553 11.1736 34.2708 11.8486 34.9458C12.5236 35.6208 13.4391 36 14.3937 36C15.3483 36 16.2638 35.6208 16.9388 34.9458C17.6138 34.2708 17.993 33.3553 17.993 32.4007C17.993 31.4461 17.6138 30.5306 16.9388 29.8556C16.2638 29.1806 15.3483 28.8014 14.3937 28.8014ZM32.3902 28.8014C31.4356 28.8014 30.5201 29.1806 29.8451 29.8556C29.1701 30.5306 28.7909 31.4461 28.7909 32.4007C28.7909 33.3553 29.1701 34.2708 29.8451 34.9458C30.5201 35.6208 31.4356 36 32.3902 36C33.3448 36 34.2602 35.6208 34.9352 34.9458C35.6102 34.2708 35.9895 33.3553 35.9895 32.4007C35.9895 31.4461 35.6102 30.5306 34.9352 29.8556C34.2602 29.1806 33.3448 28.8014 32.3902 28.8014Z"
          fill="#F79F22"
        />
      </svg>
    ),
    perks: [
      'Create bespoke carbon portfolios',
      'Every tonne offset is verified',
      'Track impact on your org’s profile',
      'Balanced offsets and removals',
    ],
    screenshot: {
      imageUrl: staticImageUrl('browser-one-off-purchases.png'),
      title: 'Intuitive removals purchase interface',
      description:
        'Enter a precise amount of carbon, or allocate your budget toward funding a Wren climate portfolio.',
    },
    features: [
      {
        title: 'Purchase high-quality offsets and removals',
        description:
          'Our offset and removal projects are verified by the most rigorous standards in the world, and span methodologies ranging from forestry to enhanced rock weathering.',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="24"
            viewBox="0 0 28 24"
            fill="none"
          >
            <path
              d="M13.7982 0.131348C13.3878 0.131348 13.0033 0.329045 12.7693 0.662559L7.09212 8.74611H1.25361C0.861956 8.74611 0.494235 8.92521 0.256491 9.23165C0.0212492 9.53686 -0.0587352 9.93325 0.0438701 10.3037L3.24784 21.7067C3.5469 22.77 4.53884 23.5143 5.65999 23.5143H21.868C22.9892 23.5143 23.9799 22.7712 24.2777 21.7091L27.4817 10.3061C27.5856 9.93443 27.5068 9.53686 27.2715 9.23165C27.0338 8.92521 26.6648 8.74611 26.2744 8.74611H20.4457L14.832 0.667367C14.5993 0.332622 14.2148 0.132578 13.8031 0.131348H13.7982ZM13.7933 3.53495L17.4128 8.74611H10.1324L13.7933 3.53495ZM2.89592 11.2075H24.6321L21.868 21.0529H5.65999L2.89592 11.2075ZM17.2588 12.1834L12.5127 16.8513L10.2692 14.6447L8.49982 16.385L12.5127 20.3318L19.0282 13.9236L17.2588 12.1834Z"
              fill="#F79F22"
            />
          </svg>
        ),
      },
      {
        title: 'View detailed reporting on every carbon project',
        description:
          'Use Wren’s research as part of your due diligence, or to share with stakeholders.',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="22"
            viewBox="0 0 27 22"
            fill="none"
          >
            <path
              d="M0 0V2.44444H1.22222V15.8889C1.22222 17.2394 2.31611 18.3333 3.66667 18.3333H12.2222V22H14.6667V18.3333H23.2222C24.5728 18.3333 25.6667 17.2394 25.6667 15.8889V2.44444H26.8889V0H0ZM3.66667 2.44444H23.2222V15.2778C23.2222 15.6151 22.9484 15.8889 22.6111 15.8889H4.27778C3.94044 15.8889 3.66667 15.6151 3.66667 15.2778V2.44444ZM17.1111 4.38281L12.2222 9.2717L9.77778 6.82726L6.16363 10.4414L7.89193 12.1697L9.77778 10.2839L12.2222 12.7283L17.1111 7.83941L18.997 9.72526L20.7253 7.99696L17.1111 4.38281Z"
              fill="#F79F22"
            />
          </svg>
        ),
      },
      {
        title: 'Every offset is third-party verified',
        description:
          'Wren follows industry-leading standards for verification of offsets and removals.',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="26"
            viewBox="0 0 22 26"
            fill="none"
          >
            <path
              d="M11.1365 0.893066L0.90918 5.36367V12.0696C0.90918 20.8208 8.22622 24.9069 11.1365 25.4814C14.0467 24.9069 21.3637 20.8208 21.3637 12.0696V5.36367L11.1365 0.893066ZM11.1365 3.34011L19.091 6.81749V12.0696C19.091 18.9253 13.6535 22.4129 11.1365 23.1762C8.61941 22.4129 3.18191 18.9253 3.18191 12.0696V6.81749L11.1365 3.34011ZM16.583 8.48742L10.0001 14.9598L6.85067 11.8622L5.24378 13.4426L10.0001 18.1206L18.1877 10.0657L16.583 8.48742Z"
              fill="#F79F22"
            />
          </svg>
        ),
      },
    ],
  },
  {
    name: 'Brand Partner',
    pageAnchorTag: 'brand-partner',
    summary:
      'Put your brand in front of Wren’s massive audience of climate-conscious consumers.',
    description:
      'Match donations, sell climate-friendly products, market your sustainability goals, and more.',
    colors: {
      primary: colors.linkBlue,
      secondary: colors.linkBlueLowOpacity,
    },
    icon: (
      <svg
        width="60%"
        height="60%"
        viewBox="0 0 39 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M38.6596 7.13387L32.3858 5.62104C31.6294 3.3518 30.3391 1.52751 28.6928 0.593118C24.4657 -1.72062 15.2998 3.26281 8.44756 6.46645C4.17605 8.46872 0.438477 8.95816 0.438477 8.95816C0.438477 8.95816 6.08933 29.7818 20.9951 27.1121C30.962 25.3323 34.1656 15.7659 33.0533 8.46872L38.6596 7.13387ZM15.2998 16.1218C10.4053 16.8783 8.58105 11.0049 8.58105 11.0049C8.58105 11.0049 11.0728 11.5834 12.3631 10.738C14.2764 9.44761 16.4566 7.97927 17.8805 8.6467C20.1052 9.75907 20.1942 15.3654 15.2998 16.1218ZM26.2455 6.59993C25.4891 6.82241 24.7327 6.33296 24.5102 5.53205C24.2878 4.73115 24.7327 3.93024 25.4446 3.75226C26.201 3.52978 26.9575 4.01923 27.1799 4.82014C27.4024 5.57655 26.9575 6.42195 26.2455 6.59993Z"
          fill="#1269D3"
        />
      </svg>
    ),
    perks: [
      'Easily promote your climate-positive brand to hundreds of thousands of climate-conscious consumers',
      'Remove carbon at the same time',
      'Access to a highly-coveted consumer audience spanning 150 countries',
    ],
    screenshot: {
      imageUrl: staticImageUrl('browser-brand-partner2.png'),
      title: 'Match every consumer purchase on Wren with your carbon budget',
      description:
        'Put your net-zero budget to work by matching Wren consumer purchases, putting your brand in front of thousands.',
    },
    features: [
      {
        title:
          'Dramatically increase the marketing reach of your net-zero efforts',
        description:
          'Already considering purchasing offsets or removals? Put that budget to work by matching Wren consumer purchases, and putting your brand in front of thousands.',
        icon: (
          <svg
            width="22"
            height="21"
            viewBox="0 0 22 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.5263 0L17.3684 2.33333L6.94737 5.83333H2.31579C1.04211 5.83333 0 6.88333 0 8.16667V12.8333C0 14.1167 1.04211 15.1667 2.31579 15.1667H4.63158V21H6.94737V15.1667L17.3684 18.6667L18.5263 21H20.8421V12.5098C21.5318 12.1058 22 11.3621 22 10.5C22 9.6379 21.5318 8.89421 20.8421 8.49023V0H18.5263ZM18.5263 4.40462V16.5954L18.1012 16.4518L9.26316 13.485V7.51497L18.1012 4.54818L18.5263 4.40462ZM2.31579 8.16667H6.94737V12.8333H4.63158H2.31579V8.16667Z"
              fill="#1269D3"
            />
          </svg>
        ),
      },
      {
        title: 'Utilize Wren’s trusted brand to enhance your product offerings',
        description:
          'Carbon-neutral products, special one-time drops, swag, and much more. As a Brand Partner, we help you craft the right sustainability story.',
        icon: (
          <svg
            width="20"
            height="25"
            viewBox="0 0 20 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 0L0 4.44444V11.1111C0 19.8111 7.15444 23.8733 10 24.4444C12.8456 23.8733 20 19.8111 20 11.1111V4.44444L10 0ZM10 2.43273L17.7778 5.88976V11.1111C17.7778 17.9267 12.4611 21.3939 10 22.1528C7.53889 21.3939 2.22222 17.9267 2.22222 11.1111V5.88976L10 2.43273ZM15.3255 7.54991L8.88889 13.9844L5.80946 10.9049L4.23828 12.4761L8.88889 17.1267L16.8945 9.11892L15.3255 7.54991Z"
              fill="#1269D3"
            />
          </svg>
        ),
      },
      {
        title: 'Flagship Partner',
        description:
          'Together, we’ll build a custom, long-term partnership unique to your business and help you develop direct relationships with our executive team.',
        icon: (
          <svg
            width="20"
            height="24"
            viewBox="0 0 20 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.3904 8.67325L11.1513 6.19518H3.71711V4.60921C4.46053 4.18794 4.95614 3.39496 4.95614 2.47807C4.95614 1.11513 3.84101 0 2.47807 0C1.11513 0 0 1.11513 0 2.47807C0 3.39496 0.495614 4.18794 1.23904 4.60921V23.5417H3.71711V18.5855H9.91228L11.1513 21.0636H19.8246V8.67325H12.3904ZM17.3465 18.5855H12.3904L11.1513 16.1075H3.71711V8.67325H9.91228L11.1513 11.1513H17.3465V18.5855Z"
              fill="#1269D3"
            />
          </svg>
        ),
      },
    ],
  },
  {
    name: 'API Integrations',
    pageAnchorTag: 'api-integrations',
    summary:
      'Embed climate action into your custom app or Shopify store’s workflow.',
    description: 'Wren’s climate API is free to use, and fully customizable.',
    colors: {
      primary: colors.textPrimary,
      secondary: colors.gray9,
    },
    icon: (
      <svg
        width="60%"
        height="60%"
        viewBox="0 0 49 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.2339 0C14.8395 0 14.4998 0.286075 14.4351 0.675659L13.9773 3.43197C13.1904 3.56722 12.4298 3.77634 11.6977 4.04764L9.91703 1.88806C9.66646 1.58253 9.23046 1.50294 8.88775 1.70178L7.27754 2.63317C6.93483 2.83039 6.7849 3.24652 6.92392 3.61509L7.90268 6.22932C7.29578 6.7351 6.7351 7.29578 6.22932 7.90268L3.61509 6.92392C3.24652 6.7849 2.83039 6.93483 2.63317 7.27754L1.70178 8.88775C1.50294 9.23046 1.58253 9.66646 1.88806 9.91703L4.04764 11.6977C3.77634 12.4298 3.56722 13.1904 3.43197 13.9773L0.675659 14.4351C0.286075 14.5014 0 14.8378 0 15.2339V17.0967C0 17.4911 0.286075 17.8308 0.675659 17.8955L3.43197 18.3533C3.56722 19.1401 3.77634 19.9008 4.04764 20.6328L1.88806 22.4136C1.58253 22.6641 1.50456 23.1001 1.70178 23.4428L2.63317 25.053C2.83039 25.3957 3.24652 25.5457 3.61509 25.4067L6.22932 24.4279C6.7351 25.0348 7.29578 25.5955 7.90268 26.1013L6.92392 28.7155C6.7849 29.0857 6.93645 29.5002 7.27754 29.6974L8.88775 30.6288C9.23046 30.826 9.66646 30.7464 9.91703 30.4425L11.6946 28.2829C12.4275 28.5547 13.1895 28.7632 13.9773 28.8986L14.4351 31.6549C14.5014 32.0445 14.8378 32.3306 15.2339 32.3306H17.0967C17.4911 32.3306 17.8308 32.0445 17.8955 31.6549L18.3533 28.8986C19.1401 28.7634 19.9008 28.5542 20.6328 28.2829L22.4136 30.4425C22.6641 30.748 23.1001 30.826 23.4428 30.6288L25.053 29.6974C25.3957 29.5002 25.5457 29.0841 25.4067 28.7155L24.4279 26.1013C25.0348 25.5955 25.5955 25.0348 26.1013 24.4279L28.7155 25.4067C29.0857 25.5457 29.5002 25.3941 29.6974 25.053L30.6288 23.4428C30.826 23.1001 30.7464 22.6641 30.4425 22.4136L28.2829 20.636C28.5547 19.9031 28.7632 19.1411 28.8986 18.3533L31.6549 17.8955C32.0445 17.8292 32.3306 17.4927 32.3306 17.0967V15.2339C32.3306 14.8395 32.0445 14.4998 31.6549 14.4351L28.8986 13.9773C28.7634 13.1904 28.5542 12.4298 28.2829 11.6977L30.4425 9.91703C30.748 9.66646 30.826 9.23046 30.6288 8.88775L29.6974 7.27754C29.5002 6.93483 29.0841 6.7849 28.7155 6.92392L26.1013 7.90268C25.5955 7.29578 25.0348 6.7351 24.4279 6.22932L25.4067 3.61509C25.5457 3.2449 25.3941 2.83039 25.053 2.63317L23.4428 1.70178C23.1001 1.50456 22.6641 1.58415 22.4136 1.88806L20.636 4.04764C19.9031 3.77583 19.1411 3.56739 18.3533 3.43197L17.8955 0.675659C17.8292 0.286075 17.4927 0 17.0967 0H15.2339ZM14.5488 6.61135V11.6188C12.6779 12.2935 11.3157 14.0749 11.3157 16.1653C11.3157 16.4675 11.3501 16.7618 11.4041 17.0493L7.07863 19.5467C6.68891 18.4936 6.46612 17.3577 6.46612 16.1653C6.46612 11.3418 9.95032 7.37751 14.5488 6.61135ZM17.7818 6.61135C22.3803 7.37751 25.8645 11.3418 25.8645 16.1653C25.8645 17.3581 25.6387 18.4933 25.2488 19.5467L20.9265 17.0493C20.9805 16.7618 21.0149 16.4675 21.0149 16.1653C21.0149 14.0749 19.6527 12.2935 17.7818 11.6188V6.61135ZM16.1653 14.5488C17.0772 14.5488 17.7818 15.2534 17.7818 16.1653C17.7818 17.0772 17.0772 17.7818 16.1653 17.7818C15.2534 17.7818 14.5488 17.0772 14.5488 16.1653C14.5488 15.2534 15.2534 14.5488 16.1653 14.5488ZM13.0427 19.8341C13.8911 20.5585 14.9739 21.0149 16.1653 21.0149C17.3566 21.0149 18.4395 20.5585 19.2878 19.8341L23.648 22.3504C21.8723 24.5001 19.186 25.8645 16.1653 25.8645C13.1446 25.8645 10.4583 24.5001 8.68253 22.3504L13.0427 19.8341Z"
          fill="#333333"
        />
        <path
          d="M37.4182 22.4526C37.151 22.4526 36.9209 22.6464 36.8771 22.9103L36.567 24.7775C36.0339 24.8692 35.5186 25.0108 35.0227 25.1946L33.8164 23.7317C33.6467 23.5247 33.3513 23.4708 33.1192 23.6055L32.0284 24.2364C31.7962 24.37 31.6947 24.6519 31.7888 24.9016L32.4519 26.6725C32.0407 27.0152 31.6609 27.395 31.3183 27.8061L29.5473 27.1431C29.2977 27.0489 29.0158 27.1505 28.8822 27.3826L28.2512 28.4734C28.1165 28.7056 28.1704 29.0009 28.3774 29.1707L29.8404 30.377C29.6566 30.8729 29.5149 31.3882 29.4233 31.9212L27.5561 32.2313C27.2922 32.2762 27.0984 32.5042 27.0984 32.7725V34.0344C27.0984 34.3016 27.2922 34.5317 27.5561 34.5755L29.4233 34.8856C29.5149 35.4187 29.6566 35.934 29.8404 36.4299L28.3774 37.6362C28.1704 37.8059 28.1176 38.1013 28.2512 38.3334L28.8822 39.4242C29.0158 39.6564 29.2977 39.7579 29.5473 39.6638L31.3183 39.0007C31.6609 39.4119 32.0407 39.7917 32.4519 40.1343L31.7888 41.9052C31.6947 42.156 31.7973 42.4368 32.0284 42.5704L33.1192 43.2014C33.3513 43.335 33.6467 43.2811 33.8164 43.0752L35.0206 41.6122C35.5171 41.7964 36.0333 41.9376 36.567 42.0293L36.8771 43.8965C36.922 44.1604 37.1499 44.3542 37.4182 44.3542H38.6801C38.9473 44.3542 39.1774 44.1604 39.2212 43.8965L39.5314 42.0293C40.0644 41.9377 40.5797 41.796 41.0756 41.6122L42.2819 43.0752C42.4516 43.2822 42.747 43.335 42.9792 43.2014L44.07 42.5704C44.3021 42.4368 44.4037 42.1549 44.3095 41.9052L43.6465 40.1343C44.0576 39.7917 44.4374 39.4119 44.7801 39.0007L46.551 39.6638C46.8018 39.7579 47.0826 39.6553 47.2162 39.4242L47.8471 38.3334C47.9807 38.1013 47.9268 37.8059 47.7209 37.6362L46.258 36.432C46.4421 35.9355 46.5833 35.4193 46.6751 34.8856L48.5422 34.5755C48.8062 34.5306 49 34.3027 49 34.0344V32.7725C49 32.5053 48.8062 32.2751 48.5422 32.2313L46.6751 31.9212C46.5834 31.3882 46.4418 30.8729 46.258 30.377L47.7209 29.1707C47.9279 29.0009 47.9807 28.7056 47.8471 28.4734L47.2162 27.3826C47.0826 27.1505 46.8007 27.0489 46.551 27.1431L44.7801 27.8061C44.4374 27.395 44.0576 27.0152 43.6465 26.6725L44.3095 24.9016C44.4037 24.6508 44.301 24.37 44.07 24.2364L42.9792 23.6055C42.747 23.4719 42.4516 23.5258 42.2819 23.7317L41.0777 25.1946C40.5813 25.0105 40.0651 24.8693 39.5314 24.7775L39.2212 22.9103C39.1763 22.6464 38.9484 22.4526 38.6801 22.4526H37.4182ZM36.9541 26.9313V30.3235C35.6867 30.7806 34.7639 31.9873 34.7639 33.4034C34.7639 33.6081 34.7872 33.8075 34.8238 34.0023L31.8936 35.6941C31.6296 34.9807 31.4787 34.2112 31.4787 33.4034C31.4787 30.1359 33.839 27.4504 36.9541 26.9313ZM39.1442 26.9313C42.2594 27.4504 44.6196 30.1359 44.6196 33.4034C44.6196 34.2114 44.4667 34.9805 44.2026 35.6941L41.2745 34.0023C41.3111 33.8075 41.3344 33.6081 41.3344 33.4034C41.3344 31.9873 40.4116 30.7806 39.1442 30.3235V26.9313ZM38.0492 32.3083C38.6669 32.3083 39.1442 32.7857 39.1442 33.4034C39.1442 34.0212 38.6669 34.4985 38.0492 34.4985C37.4314 34.4985 36.9541 34.0212 36.9541 33.4034C36.9541 32.7857 37.4314 32.3083 38.0492 32.3083ZM35.9339 35.8887C36.5086 36.3795 37.2421 36.6887 38.0492 36.6887C38.8562 36.6887 39.5898 36.3795 40.1645 35.8887L43.1182 37.5934C41.9152 39.0497 40.0955 39.9739 38.0492 39.9739C36.0029 39.9739 34.1831 39.0497 32.9802 37.5934L35.9339 35.8887Z"
          fill="#333333"
        />
      </svg>
    ),
    perks: [
      'Dynamically purchase offsets',
      'Simple Shopify integration',
      'Offset shipping emissions',
    ],
    screenshot: {
      imageUrl: staticImageUrl('browser-custom-integrations.png'),
      title: 'Plant a tree at checkout',
      description:
        'With Wren’s Shopify app, you can easily plant 1 tree for every order placed by a customer. Set up in less than 5 minutes.',
    },
    features: [
      {
        title: 'Shopify integration',
        description:
          'Sell through Shopify? Start planting trees or supporting climate projects with every order placed.',
        icon: (
          <svg
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.43671 0C8.76444 0 8.16326 0.31291 7.7266 0.711346C7.28995 1.10978 6.96724 1.60022 6.69192 2.15799C6.24113 3.07122 5.92786 4.19058 5.73148 5.44647L2.43103 6.42606L0 24.0373L16.1598 27L16.3873 26.9545L26.1857 25.0312L23.005 4.41418L17.2376 2.03584L16.0041 2.40229C15.806 2.00801 15.5844 1.64117 15.3263 1.31731C14.7478 0.591471 13.9129 0 12.9048 0C12.1975 0 11.6195 0.3341 11.1109 0.759248C10.653 0.339823 10.1213 0 9.43671 0ZM9.43671 2.45259C9.35761 2.45259 9.46405 2.42106 9.71933 2.78551C9.9098 3.05743 10.1142 3.53633 10.3013 4.09323L8.38765 4.66087C8.53436 4.09457 8.70865 3.61163 8.89062 3.24297C9.07163 2.87627 9.26155 2.62942 9.37923 2.52204C9.4969 2.41467 9.4897 2.45259 9.43671 2.45259ZM12.9048 2.45259C12.9563 2.45259 13.1159 2.4792 13.4078 2.84538C13.4616 2.9129 13.5174 3.03676 13.5731 3.12321L12.6102 3.40823C12.5277 3.24096 12.4442 3.07735 12.3731 2.89568C12.6629 2.52457 12.8527 2.45259 12.9048 2.45259ZM16.1885 4.90517L15.0101 24.2959L2.75197 22.0493L4.64411 8.32777L16.1885 4.90517ZM18.6243 5.25965L20.7919 6.15302L23.4026 23.0792L17.4723 24.2432L18.6243 5.25965ZM11.1109 9.81513C8.19967 9.81513 6.76377 11.7795 6.76377 13.8078C6.76377 16.2309 9.13253 16.293 9.13253 17.7597C9.13253 18.1165 8.87993 18.6028 8.26311 18.6028C7.3299 18.6028 6.22248 17.6328 6.22248 17.6328L5.65484 19.5201C5.65484 19.5201 6.71416 20.847 8.83075 20.847C10.5831 20.847 11.8797 19.5077 11.8797 17.4292C11.8797 14.7902 8.98164 14.3574 8.98164 13.2353C8.98164 13.0318 9.04703 12.2007 10.3445 12.2007C11.2139 12.2007 11.9444 12.5958 11.9444 12.5958L12.7515 10.1361C12.7515 10.1361 12.1962 9.80287 11.1109 9.81513Z"
              fill="#333333"
            />
          </svg>
        ),
      },
      {
        title: 'Unlimited, free API access',
        description:
          'We don’t charge for access to our API, as long as you have an account.',
        icon: (
          <svg
            width="36"
            height="24"
            viewBox="0 0 36 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.18788 0C1.4456 0 0 1.4456 0 3.18788V20.7212C0 22.4635 1.4456 23.9091 3.18788 23.9091H31.8788C33.6211 23.9091 35.0667 22.4635 35.0667 20.7212V3.18788C35.0667 1.4456 33.6211 0 31.8788 0H3.18788ZM3.18788 3.18788H31.8788V20.7212H3.18788V3.18788ZM11.7086 7.9697L9.56364 15.9394H11.2416L11.6526 14.3455H13.8318L14.2458 15.9394H15.9394L13.782 7.9697H11.7086ZM17.5333 7.9697V15.9394H19.1273V12.7515H19.9242C21.244 12.7515 22.3152 11.6804 22.3152 10.3606C22.3152 9.04082 21.244 7.9697 19.9242 7.9697H17.5333ZM23.9091 7.9697V15.9394H25.503V7.9697H23.9091ZM19.1273 9.56364H19.9242C20.3642 9.56364 20.7212 9.92068 20.7212 10.3606C20.7212 10.8005 20.3642 11.1576 19.9242 11.1576H19.1273V9.56364ZM12.7391 10.1271L13.4208 12.7515H12.0635L12.7391 10.1271Z"
              fill="#333333"
            />
          </svg>
        ),
      },
      {
        title: 'Calculate emissions',
        description:
          'Calculate the emissions associated with shipping, transport, and more.',
        icon: (
          <svg
            width="20"
            height="25"
            viewBox="0 0 20 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.5 0H2.5C1.11875 0 0 1.11875 0 2.5V22.5C0 23.8813 1.11875 25 2.5 25H17.5C18.8813 25 20 23.8813 20 22.5V2.5C20 1.11875 18.8813 0 17.5 0ZM17.5 7.5H2.5V2.5H17.5V7.5ZM6.25 12.5H3.75V10H6.25V12.5ZM6.25 17.5H3.75V15H6.25V17.5ZM6.25 22.5H3.75V20H6.25V22.5ZM16.25 22.5H8.75V20H16.25V22.5ZM11.25 17.5H8.75V15H11.25V17.5ZM16.25 17.5H13.75V15H16.25V17.5ZM16.25 12.5H13.75V10H16.25V12.5ZM11.25 12.5H8.75V10H11.25V12.5Z"
              fill="#333333"
            />
          </svg>
        ),
      },
    ],
  },
  {
    name: 'Custom Portfolio',
    pageAnchorTag: 'custom-deal',
    summary:
      'Build a portfolio tailored to your goals, budget, and impact priorities.',
    description: '',
    cta: 'Reach out',
    colors: {
      primary: '#D6AC18',
      secondary: '#F3C5231A',
    },
    icon: (
      <svg
        width="60%"
        height="60%"
        viewBox="0 0 33 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.3445 5.48488L17.9164 13.7122L9.68911 17.1402L17.9164 20.5683L21.3445 28.7956L24.7725 20.5683L32.9998 17.1402L24.7725 13.7122L21.3445 5.48488ZM5.74686 9.42714L7.63228 15.0834L9.51771 9.42714L15.174 7.54171L9.51771 5.65628L7.63228 0L5.74686 5.65628L0.0905762 7.54171L5.74686 9.42714ZM8.8321 24.1677L7.63228 20.5683L6.43247 24.1677L2.83302 25.3676L6.43247 26.5674L7.63228 30.1668L8.8321 26.5674L12.4316 25.3676L8.8321 24.1677Z"
          fill="#D6AC18"
        />
      </svg>
    ),
    perks: [
      'Free consultation',
      'Talk with our climate scientists, engineers, and marketers to see how we can help on your net-zero journey',
    ],
  },
];

export const newBusinessGridProducts = [
  {
    name: 'Measure your emissions',
    pageAnchorTag: 'measure-emissions',
    summary:
      'A free GHG Protocol calculator, about five minutes. When you’re done, offset it in one click.',
    href: '/emissions',
    colors: {
      primary: colors.linkBlue,
      secondary: colors.linkBlueLowOpacity,
    },
    icon: <Calculator color={colors.linkBlue} size="60%" weight="fill" />,
  },
  {
    name: 'Show your impact',
    pageAnchorTag: 'show-impact',
    summary:
      'Get a shareable public profile and a certificate for every purchase your team makes.',
    href: '#dashboard-showcase',
    colors: {
      primary: colors.wrenGreen,
      secondary: colors.wrenGreenLowOpacity,
    },
    icon: <Megaphone color={colors.wrenGreen} size="60%" weight="fill" />,
  },
];

export default businessProducts;
